import {
  IconDatabaseDollar,
  IconHeartHandshake,
  IconLogout,
  IconMountain,
  IconPresentationAnalytics,
} from '@tabler/icons-react';
import React from 'react';
import { useDispatch } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { logout } from '../../../redux/authSlice';

const Sidebar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { company } = useParams();

  const handleLogout = () => {
    dispatch(logout());
    navigate(`/${company}`);
  };
  return (
    <aside className='admin-aside'>
      <div className={`logo ${company}`} />
      <nav>
        <ul>
          <li>
            <Link to={`/${company}/admin/dashboard`}>
              <IconPresentationAnalytics />
              <span>Dashboard</span>
            </Link>
          </li>
          <li>
            <Link to={`/${company}/admin/foundations`}>
              <IconHeartHandshake />
              <span>Fundaciones</span>
            </Link>
          </li>
          <li>
            <Link to={`/${company}/admin/campaigns`}>
              <IconMountain />
              <span>Campañas</span>
            </Link>
          </li>
          {/* <li>
            <Link to='/admin/disbursements'><span>Desembolsos</span></Link>
          </li> */}
          <li>
            <Link to={`/${company}/admin/transactions`}>
              <IconDatabaseDollar />
              <span>Transacciones</span>
            </Link>
          </li>
        </ul>
      </nav>
      <button onClick={handleLogout}>
        <IconLogout /> <span>Logout</span>
      </button>
    </aside>
  );
};

export default Sidebar;
